import React, { type ReactNode } from 'react';

import type { MaybeChoreographedComponentProps, ChoreographerUtilities } from '../../types';

type ChildrenWrapperProps = { children: ReactNode };

const ChildrenWrapper = ({ children }: ChildrenWrapperProps): React.ReactElement => (
	<>{children}</>
);

type ChoreographedComponentProps = MaybeChoreographedComponentProps & ChoreographerUtilities & { children: ReactNode };

export const ChoreographedComponent = ({
  messageType,
  messageId,
  onMessageDisposition,
  shouldBeChoreographed,
  withChoreographedRender,
  children,
}: ChoreographedComponentProps): React.ReactElement => {
  const ChoreographedChildrenWrapper = React.useMemo(
    () => withChoreographedRender(ChildrenWrapper),
    [withChoreographedRender]
  );

  if (!shouldBeChoreographed({ messageId, messageType, onMessageDisposition })) {
    return <>{children}</>;
  }

  return (
    <ChoreographedChildrenWrapper messageId={messageId!} onMessageDisposition={onMessageDisposition}>
      {children}
    </ChoreographedChildrenWrapper>
  );
};
